import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { PATH_BENEFITS_PERKS, PATH_BENEFITS_PERKS_PREVIEW } from "../../paths";
import { RouteAllMyBenefits } from "./RouteAllMyBenefits";
import { BENEFITS_PERKS_TABS } from "./contsants";
import { RouteBenefitDetails } from "../RouteBenefitDetails";

export const RouteBenefitsPremiumPerksIndex: React.FC = () => {
  return (
    <Switch>
      <Route
        path={`${PATH_BENEFITS_PERKS}/:tab/:benefit`}
        exact
        component={RouteBenefitDetails}
      />
      <Route
        path={`${PATH_BENEFITS_PERKS_PREVIEW}/:benefit`}
        exact
        component={RouteBenefitDetails}
      />
      <Route
        path={[
          PATH_BENEFITS_PERKS,
          ...BENEFITS_PERKS_TABS.map(
            tabPath => `${PATH_BENEFITS_PERKS}/${tabPath}`
          )
        ]}
        component={RouteAllMyBenefits}
      />

      <Redirect from="*" to={PATH_BENEFITS_PERKS} />
    </Switch>
  );
};
